
          import $$Component from "/home/runner/work/wp-tm-rpg168/wp-tm-rpg168/typescript/popup/Login.vue?vue&type=script"
          
          import { render } from "/home/runner/work/wp-tm-rpg168/wp-tm-rpg168/typescript/popup/Login.vue?vue&type=template"
          export * from "/home/runner/work/wp-tm-rpg168/wp-tm-rpg168/typescript/popup/Login.vue?vue&type=template"
          $$Component.render = render
          export default $$Component